import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useRemediation } from '../../context/RemediationContext';

const { FiActivity, FiAlertTriangle, FiBookOpen, FiBell, FiCheckCircle, FiTrendingDown } = FiIcons;

const logConfig = {
  failure: { icon: FiAlertTriangle, color: 'text-red-500 bg-red-50 border-red-100' },
  assignment: { icon: FiBookOpen, color: 'text-blue-500 bg-blue-50 border-blue-100' },
  notification: { icon: FiBell, color: 'text-violet-500 bg-violet-50 border-violet-100' },
  completion: { icon: FiCheckCircle, color: 'text-emerald-500 bg-emerald-50 border-emerald-100' },
  adjustment: { icon: FiTrendingDown, color: 'text-teal-500 bg-teal-50 border-teal-100' },
};

const ActivityLog = () => {
  const { activityLog } = useRemediation();

  return (
    <div className="bg-white rounded-xl border border-slate-200 shadow-sm p-5">
      <div className="flex items-center gap-2 mb-4">
        <SafeIcon icon={FiActivity} className="text-slate-500" />
        <h3 className="text-sm font-semibold text-slate-700">Activity Log</h3>
        <span className="text-xs text-slate-400 ml-auto">{activityLog.length} events</span>
      </div>
      {activityLog.length === 0 ? (
        <p className="text-xs text-slate-400 text-center py-4">No activity yet. Trigger a phishing failure to see the workflow in action.</p>
      ) : (
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {activityLog.map((entry, i) => {
            const cfg = logConfig[entry.type] || logConfig.failure;
            return (
              <motion.div key={entry.id} initial={{ opacity: 0, x: -8 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: i * 0.03 }}
                className={`flex items-start gap-2.5 p-2.5 rounded-lg border ${cfg.color}`}>
                <SafeIcon icon={cfg.icon} className="flex-shrink-0 mt-0.5 text-sm" />
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-slate-700 leading-snug">{entry.message}</p>
                  <p className="text-xs text-slate-400 mt-0.5">{new Date(entry.timestamp).toLocaleTimeString()}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ActivityLog;